import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { Avatar, Badge } from "antd";
import { UserOutlined } from "@ant-design/icons";
import Cookies from "js-cookie";

import { Button, Typography } from "@atoms";
import { useIsMobile } from "hooks";
import { clearProfile, useAppSelector } from "store";
import CandleIcon from "@assets/icons/candle.svg";
import MenuIcon from "@assets/icons/menu.svg";
import CancelIcon from "@assets/icons/cancel.svg";
import { ReactComponent as VkIcon } from "assets/icons/vk2.svg";
import { ReactComponent as TgIcon } from "assets/icons/tg2.svg";

import {
  HeaderContainer,
  Nav,
  Profile,
  Logout,
  Candle,
  StyledLink,
  SidebarFooter,
  StyledLinkFooter, MediaWrapper, MediaIcons, MediaIcon, LegalInfo, Copyright
} from "./header.styles";
import { IHeader } from "./header.type";
import { useTranslation } from "react-i18next";

const MobileNav = ({ open, setOpen }: {open: boolean, setOpen: (value: boolean) => void}) => {
  // @ts-ignore
  const { profile } = useAppSelector((state) => state.profile);
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const sideBarRef = useRef<HTMLDivElement>(null);

  const handleProfile = () => {
    navigate("/profile");
  };

  const handleLogout = () => {
    // @ts-ignore
    dispatch(clearProfile());
    Cookies.remove("access");
    Cookies.remove("refresh");
    localStorage.clear();
    navigate("/");
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (sideBarRef.current && !sideBarRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      ref={sideBarRef}
      style={{
        position: "fixed",
        inset: "0px",
        left: "83px",
        background: "#F9F2EC",
        transform: open ? "translateX(0)" : "translateX(100%)",
        opacity: open ? 1 : 0,
        transition: "transform 0.3s ease-in-out, opacity 0.3s ease-in-out",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between"
      }}
    >
      <Nav>
        <img
          src={CancelIcon}
          onClick={() => setOpen(false)}
          alt="cancel"
          style={{
            width: "16px",
            marginLeft: "auto",
            marginRight: "16px",
          }}
        />
        {profile && (
          <div>
            <Badge count={profile?.new_tribute_count || null} onClick={() => navigate("/profile")}>
              <Avatar
                size={32}
                style={{background: "#C6A691"}}
                icon={
                  profile?.image ? (
                    <img src={profile.image} alt="avatar"/>
                  ) : (
                    <UserOutlined/>
                  )
                }
              />
            </Badge>
            <Typography style={{color: "#594E47"}} onClick={handleProfile}>
              {profile?.username}
            </Typography>
            <Logout onClick={handleLogout}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M12 15L15 12M15 12L12 9M15 12H4M9 7.24859V7.2002C9 6.08009 9 5.51962 9.21799 5.0918C9.40973 4.71547 9.71547 4.40973 10.0918 4.21799C10.5196 4 11.0801 4 12.2002 4H16.8002C17.9203 4 18.4796 4 18.9074 4.21799C19.2837 4.40973 19.5905 4.71547 19.7822 5.0918C20 5.5192 20 6.07899 20 7.19691V16.8036C20 17.9215 20 18.4805 19.7822 18.9079C19.5905 19.2842 19.2837 19.5905 18.9074 19.7822C18.48 20 17.921 20 16.8031 20H12.1969C11.079 20 10.5192 20 10.0918 19.7822C9.71547 19.5905 9.40973 19.2839 9.21799 18.9076C9 18.4798 9 17.9201 9 16.8V16.75"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
              </svg>
            </Logout>
          </div>
        )}


        <Typography
          as="h4"
          style={{cursor: "pointer", background: location.pathname.startsWith("/my-stories") ? "#BD987F33" : "inherit"}}
          onClick={() => navigate("/my-stories")}
        >
          {t("myStories")}
        </Typography>
        {/*<Typography*/}
        {/*  as="h4"*/}
        {/*  style={{cursor: "pointer", background: location.pathname.startsWith("/stories") ? "#BD987F33" : "inherit"}}*/}
        {/*  onClick={() => navigate("/stories")}*/}
        {/*>*/}
        {/*  {t("stories")}*/}
        {/*</Typography>*/}
        <Typography
          as="h4"
          style={{cursor: "pointer", background: location.pathname.startsWith("/profile") ? "#BD987F33" : "inherit"}}
          onClick={() => navigate("/profile")}
        >
          {t("profile")}
        </Typography>
        <Typography
          as="h4"
          style={{ cursor: "pointer", background: location.pathname.startsWith("/feedback") ? "#BD987F33" : "inherit" }}
          onClick={() => navigate("/feedback")}
        >
          {t("feedback")}
        </Typography>
      </Nav>
      <SidebarFooter>
        <MediaWrapper>
          <Typography>{t("ourSocials")}</Typography>
          <MediaIcons>
            <a href="https://t.me/myft_ru"><MediaIcon><TgIcon/></MediaIcon></a>
            <a href="https://vk.com/public220419224"><MediaIcon><VkIcon/></MediaIcon></a>
          </MediaIcons>
        </MediaWrapper>
        <LegalInfo>
          <Typography>
            <StyledLinkFooter to="/policy">
              {t("privacyPolicy")}
            </StyledLinkFooter>
          </Typography>
          <Typography>
            <StyledLinkFooter to="/policy">
              {t("publicOffer")}
            </StyledLinkFooter>
          </Typography>
          <Copyright>
            © myft 2025
          </Copyright>
        </LegalInfo>
      </SidebarFooter>
    </div>
  )
}

const Header: React.FC<IHeader> = () => {
  const { profile } = useAppSelector((state) => state.profile);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile(767);
  const [open, setOpen] = useState(false)

  useEffect(() => {
    setOpen(false);
  }, [location]);

  const handleLogout = () => {
    // @ts-ignore
    dispatch(clearProfile());
    Cookies.remove("access");
    Cookies.remove("refresh");
    localStorage.clear();
    navigate("/");
  };

  const handleProfile = () => {
    navigate("/profile");
  };

  return (
    <HeaderContainer isHome={location.pathname === "/"}>
      <Typography
        as="h3"
        style={{ cursor: "pointer", color: "#391D0A", fontWeight: 600 }}
        onClick={() => navigate("/")}
      >
        {t("myLight")}
      </Typography>
      {!isMobile && (
        <Nav>
          <Typography
            style={{
              cursor: "pointer",
              color: location.pathname.startsWith("/my-stories") ? "#C6A691" : "#594E47",
            }}
          >
            <StyledLink to="/my-stories">
              {t("myStories")}
            </StyledLink>
          </Typography>
          {/*<Typography*/}
          {/*  style={{*/}
          {/*    cursor: "pointer",*/}
          {/*    color: location.pathname.startsWith("/stories") ? "#C6A691" : "#594E47",*/}
          {/*  }}*/}
          {/*>*/}
          {/*  <StyledLink to="/stories">*/}
          {/*    {t("stories")}*/}
          {/*  </StyledLink>*/}
          {/*</Typography>*/}
          <Typography
            style={{
              cursor: "pointer",
              color: location.pathname.startsWith("/feedback") ? "#C6A691" : "#594E47",
            }}
          >
            <StyledLink to="/feedback">
              {t("feedback")}
            </StyledLink>
          </Typography>
        </Nav>
      )}
      {profile ? (
        <Profile>
          <Candle onClick={() => navigate("/profile")}>
            <img src={CandleIcon} alt="candle" />
            <div>
              {profile?.energy_count}
              <span>/7</span>
            </div>
          </Candle>
          <Badge count={profile?.new_tribute_count || null} onClick={() => navigate("/profile")}>
            <Avatar
              size={32}
              style={{ background: "#C6A691" }}
              icon={
                profile?.image ? (
                  <img src={profile.image} alt="avatar" />
                ) : (
                  <UserOutlined />
                )
              }
              onClick={handleProfile}
            />
          </Badge>
          {!isMobile && profile?.username && (
            <Typography style={{ color: "#594E47" }} onClick={handleProfile}>
              {profile?.username}
            </Typography>
          )}
          {!isMobile && (
            <Logout onClick={handleLogout}>
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g>
                  <path
                    d="M12 15L15 12M15 12L12 9M15 12H4M9 7.24859V7.2002C9 6.08009 9 5.51962 9.21799 5.0918C9.40973 4.71547 9.71547 4.40973 10.0918 4.21799C10.5196 4 11.0801 4 12.2002 4H16.8002C17.9203 4 18.4796 4 18.9074 4.21799C19.2837 4.40973 19.5905 4.71547 19.7822 5.0918C20 5.5192 20 6.07899 20 7.19691V16.8036C20 17.9215 20 18.4805 19.7822 18.9079C19.5905 19.2842 19.2837 19.5905 18.9074 19.7822C18.48 20 17.921 20 16.8031 20H12.1969C11.079 20 10.5192 20 10.0918 19.7822C9.71547 19.5905 9.40973 19.2839 9.21799 18.9076C9 18.4798 9 17.9201 9 16.8V16.75"
                    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </g>
              </svg>
            </Logout>
          )}
          {isMobile && (
            <Logout onClick={() => setOpen(true)}>
              <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.66797 22.6673H17.3346M6.66797 16.0007H25.3346M14.668 9.33398H25.3346" stroke="#615E5C"
                      stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </Logout>
          )}
      <MobileNav open={open} setOpen={setOpen}/>
    </Profile>
  )
:
  (
    <Profile>
      <Button className="unLogin" onClick={() => navigate("/login")} variant="text">
            {t("logined")}
          </Button>
          <Button
            className="unLogin"
            onClick={() => navigate("/register")}
          >
            {t("register")}
          </Button>
          {isMobile && (
            <img src={MenuIcon} onClick={() => setOpen(true)} alt="menu" />
          )}
          <MobileNav open={open} setOpen={setOpen} />
        </Profile>
      )}
    </HeaderContainer>
  );
};

export default Header;
